export const FETCH_STATISTICS = 'FETCH_STATISTICS';
